import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import Cards from "@Elementos/Composicion/Cards/Cards";
import Filtros from "@Composicion/Filtros/Filtros";
import MPedidoDetalle from "@Pedidos/Modales/MPedidoDetalle";
import MPedidoEliminar from "@Pedidos/Modales/MPedidoEliminar";

import img_borrar from "@Iconos/borrar.png";

import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";
import "./ListarPedidos.css";

function ListarPedidos() {
  const origenComponente = "ListarPedidos";
  const { ecv_u, cv_u, usuarioSesion, esComputadora, rolUsuarioSesion } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [
      {
        tipo: "input",
        visible: true,
        campofiltro: "Usuario Solicitante",
        operador: "contains",
        tipoDato: "str",
      },
      {
        tipo: "input",
        visible: true,
        campofiltro: "Nro. Pedido",
        operador: "==",
        tipoDato: "int",
      },
      {
        tipo: "date",
        visible: true,
        campofiltro: "F. Programada",
        operador: ">=",
        tipoDato: "date",
      },
    ],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},

    //DATOS USUARIO
    da_distribuidores: [],
    d_codigoDistribuidor: "",
    da_ayudantes: [],
    d_codigoAyudante: "",
    d_nombreUsuarioSeleccionado: "",
    d_codigoUsuarioSeleccionado: "",
    d_deudaTotal: 0,
    da_pedidos: [],

    d_actualizarTabla: false,
    //ESTADO PROCESAOR API
    i_procesandoApi: false,
    i_primeraCarga: true,
  });

  useEffect(() => {
    console.log(origenComponente, "usuarioSesion:", usuarioSesion);
    if (!["DIST01", "ADIST01"].includes(rolUsuarioSesion)) {
      const listaDistribuidoresAPI = _api_.f_listaDistribuidores({
        timeout: 5000,
        origen: origenComponente,
      });
      listaDistribuidoresAPI.respuesta.then((dPC) => {
        _f_.asignar(ecv_u, dPC, true, origenComponente);
        if (!dPC.error) {
          console.log(dPC.contenido);
          _f_.asignar(ev_u, {
            da_distribuidores: dPC.contenido.Distribuidores,
          });
        }
        _f_.asignar(ev_u, { i_primeraCarga: false });
      });
    }
  }, [recargaComponente]);

  useEffect(() => {
    let listaAyudantesAPI;
    if (rolUsuarioSesion == "DIST01") {
      listaAyudantesAPI = _api_.f_listarAyudantesDistribuidor({
        parametros: { codUsuario: usuarioSesion },
        timeout: 5000,
        origen: origenComponente,
      });
    } else if (v_u.d_codigoDistribuidor !== "" && v_u.d_codigoAyudante == "") {
      listaAyudantesAPI = _api_.f_listarAyudantesDistribuidor({
        parametros: { codUsuario: v_u.d_codigoDistribuidor },
        timeout: 5000,
        origen: origenComponente,
      });
    }
    listaAyudantesAPI?.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      if (!dPC.error) {
        //console.log(dPC.contenido);
        _f_.asignar(ev_u, {
          da_ayudantes: dPC.contenido.ayudanteDistribuidores,
        });
      }
    });
  }, [v_u.d_codigoDistribuidor, v_u.d_codigoAyudante]);

  useEffect(() => {
    const listaPedidosAPI = _api_.f_listarPedidos({
      parametros: {
        codUsuario: v_u.d_codigoUsuarioSeleccionado,
        fecha_filtro: "",
        orden: 2,
        fecha: 2,
      },
      timeout: 5000,
      origen: origenComponente,
    });
    listaPedidosAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC.contenido);
      if (!dPC.error) {
        dPC.contenido?.Pedidos?.map((elemento, idx) => {
          elemento["funcionEvento"] = {
            modo: "MODAL",
            componente: "MPedidoDetalle",
            titulo: "Detalle del Pedido",
            tipo: "onClick",
            endpoint: "actualizarRemates",
            timeout: 5000,
            estilos: {
              anchoMI: "90%",
              altoMI: "90%",
            },
          };
        });
        _f_.asignar(ev_u, {
          d_deudaTotal: dPC.contenido.Deuda,
          da_pedidos: dPC.contenido.Pedidos,
        });
      }
    });
  }, [v_u.d_codigoUsuarioSeleccionado, recargaComponente]);

  useEffect(() => {
    // console.log("dist:", v_u.d_codigoDistribuidor);
    // console.log("ayud:", v_u.d_codigoAyudante);
    // console.log("selec:", v_u.d_codigoUsuarioSeleccionado);
  }, [v_u.d_codigoDistribuidor, v_u.d_codigoAyudante, v_u.d_codigoUsuarioSeleccionado]);

  return (
    <div className={"ListarPedidosCSS-contenedor"}>
      {/* {v_c.modal_mostrar && <ModalInformacion />} */}
      <div className="titulo-componente">{"Lista de Pedidos"}</div>
      <div className={"ListarPedidosCSS-cabecera"}>
        {["SADM01"].includes(rolUsuarioSesion) &&  <_div_.Div2
          estilos={{ fuente: "1.5rem" }}
          texto={`Deuda Total: ${_f_.formatearValor({ valor: v_u.d_deudaTotal, tipo: "moneda", moneda: "PEN", precision: "2" })}`}
        />}
        {!["DIST01", "ADIST01"].includes(rolUsuarioSesion) && (
          <_opt_.Opcion2
            texto="Distribuidores"
            clave={["codUsuario"]}
            valor={["Nombre", "ApellidoPaterno", "ApellidoMaterno"]}
            opciones={v_u.da_distribuidores || []}
            name={"wefwfwefwef"}
            estilos={{ flexGrow: 0, width: "100%" }}
            seleccionado={v_u.d_codigoDistribuidor}
            onBlur={(evento) => {
              //console.log("distribuidores", evento.target.value);
              _f_.asignar(ev_u, {
                d_codigoDistribuidor: evento.target.getAttribute("value"),
                d_codigoAyudante: "",
                da_ayudantes: [],
                da_grid: [],
                da_headgrid: [],
                do_datosTabla: {},
                d_nombreUsuarioSeleccionado: evento.target.value,
                d_codigoUsuarioSeleccionado: evento.target.getAttribute("value"),
              });
            }}
          />
        )}
        <_opt_.Opcion2
          texto="Ayudantes Distribuidor"
          clave={["codUsuario"]}
          valor={["Nombre", "ApellidoPaterno", "ApellidoMaterno"]}
          opciones={v_u.da_ayudantes || []}
          name={"wefwfwefwef"}
          estilos={{ flexGrow: 0, width: "100%" }}
          seleccionado={v_u.d_codigoAyudante}
          onBlur={(evento) => {
            console.log("ayudantes", evento.target);
            _f_.asignar(ev_u, {
              d_codigoAyudante: evento.target.getAttribute("value"),
              d_codigoUsuarioSeleccionado:
                evento.target.getAttribute("value") == ""
                  ? v_u.d_codigoDistribuidor
                  : evento.target.getAttribute("value"),
            });
          }}
        />
      </div>
      <Filtros
        filtros={v_u.do_filtros}
        funcionObtenerValores={(valores) => {
          console.log(valores);
          _f_.asignar(ev_u, { do_filtrosActualizados: valores });
        }}
      />
      <div className={"ListarPedidosCSS-cuerpo"}>
        {Array.from({ length: 1 }).map((pedido, idx_pedido) => {
          const filaCabecera = {
            columnas: 2,
            alineacion: "between",
            items: [
              {
                label: "Usuario Solicitante",
                campo: "nombreUsuarioSolicitante", // Ruta directa o anidada (ej: "datos.nombre")
                mostrarLabel: false,
                claseDato: "CardsCSS-valor-principal",
              },
              {
                label: "Nro. Pedido",
                campo: "codPedido",
                mostrarLabel: false,
                claseDato: "CardsCSS-badge",
                // O si quieres formatearlo:
                valor: (val) => `Nro. ${String(val).padStart(8, "0")}`,
              },
              {
                label: "Usuario",
                campo: "usuarioSolicitante",
                oculto: true,
              },
            ],
          };

          const filaPersonal = {
            columnas: 2,
            items: [
              { label: "Recepción", campo: "nombreUsuarioRecepcionante" },
              { label: "Despacho", campo: "nombreUsuarioEntrega" },
            ],
          };

          const filaFechas = {
            columnas: 3,
            items: [
              {
                label: "F. Solicitada",
                campo: "fechaPedido", // 💡 Aquí le dices exactamente qué clave buscar (incluso anidada: "datos.pedido.fecha")
                valor: (fechaCruda) =>
                  _f_.formatearFecha({
                    valor: fechaCruda,
                    incluirHora: true,
                    formato: "dd/mm/yyyy hh:MM:ss a",
                    formatoHora: 12,
                  }),
              },
              {
                label: "F. Programada",
                campo: "fechaEntregada",
                valor: (fechaCruda) =>
                  _f_.formatearFecha({
                    valor: fechaCruda,
                    incluirHora: true,
                    formato: "dd/mm/yyyy hh:MM:ss a",
                    formatoHora: 12,
                  }),
              },
              {
                label: "F. Entrega",
                campo: "fechaEntregadaReal",
                valor: (fechaCruda) =>
                  _f_.formatearFecha({
                    valor: fechaCruda,
                    incluirHora: true,
                    formato: "dd/mm/yyyy",
                    formatoHora: 12,
                  }),
              },
            ],
          };

          const filaTotales = {
            columnas: 3,
            items: ["DESP01"].includes(rolUsuarioSesion)
              ? []
              : [
                  {
                    label: "Total Pedido",
                    campo: "totalPedido",
                    valor: (monto) =>
                      _f_.formatearValor({
                        valor: monto,
                        tipo: "moneda",
                        moneda: "PEN",
                        precision: "2",
                      }),
                  },
                  {
                    label: "Total Entregado",
                    campo: "totalEntrega",
                    valor: (monto) =>
                      _f_.formatearValor({
                        valor: monto,
                        tipo: "moneda",
                        moneda: "PEN",
                        precision: "2",
                      }),
                  },
                  {
                    label: "Total Pagado",
                    campo: "montoPagado",
                    valor: (monto) =>
                      _f_.formatearValor({
                        valor: monto,
                        tipo: "moneda",
                        moneda: "PEN",
                        precision: "2",
                      }),
                    claseDato: "CardsCSS-text-success",
                  },
                ],
          };

          const filaInferior = {
            columnas: 2,
            alineacion: "inferior",
            items: [
              {
                label: "Saldo pendiente",
                campo: "deuda",
                valor: (monto) =>
                  _f_.formatearValor({
                    valor: monto,
                    tipo: "moneda",
                    moneda: "PEN",
                    precision: "2",
                  }),
                claseDato: "CardsCSS-valor-saldo",
                reglasVisible: [
                  {
                    campo: "rolUsuarioSesion",
                    criterio: ["DESP01"],
                    operador: "!=",
                    conector: "and",
                    origen: "contexto",
                  },
                ],
              },
              {
                oculto: true,
                label: "",
                valor: (
                  <div className="CardsCSS-acciones-medio">
                    <button className="CardsCSS-btn CardsCSS-btn-primary">Generar Pago</button>
                    <button className="CardsCSS-btn CardsCSS-btn-secondary">Ver Pagos</button>
                  </div>
                ),
              },
              {
                funcionEvento: {
                  modo: "MODAL",
                  componente: "MPedidoEliminar",
                  titulo: "Eliminar Pedido",
                  tipo: "onClick",
                  endpoint: "actualizarRemates",
                  timeout: 5000,
                  estilos: {
                    anchoMI: "30rem",
                    altoMI: "",
                  },
                },

                label: "",

                valor: !["ADIST01", "DIST01"].includes(rolUsuarioSesion) && (
                  <_btn_.Boton
                    tipo={"btn-2"}
                    imagen={img_borrar}
                    estilos={{
                      color: "var(--color_transparente)",
                      anchoB2: "2.6rem",
                      altoB2: "2.6rem",
                    }}
                  />
                ),

                claseContenedor: "CardsCSS-alinear-derecha",

                reglasVisible: [
                  {
                    campo: "entregado",
                    criterio: "N",
                    operador: "==",
                    conector: "or",
                    origen: "registro",
                  },
                  {
                    campo: "rolUsuarioSesion",
                    criterio: ["SADM01"],
                    operador: "in",
                    conector: "and",
                    origen: "contexto",
                  },
                  ...(!["SADM01"].includes(rolUsuarioSesion)
                    ? [
                        {
                          campo: "deuda",
                          criterio: 0,
                          operador: "==",
                          conector: "and",
                          origen: "registro",
                        },
                      ]
                    : []),
                ],
              },
            ],
          };
          return (
            <Cards
              origenComponente={origenComponente}
              key={idx_pedido}
              elementos={v_u.da_pedidos}
              filtros={v_u.do_filtrosActualizados}
              contextoReglas={{
                rolUsuarioSesion: rolUsuarioSesion,
              }}
              filasDatos={[filaCabecera, filaPersonal, filaFechas, filaTotales, filaInferior]}
              fNotificarActualizacionDeTabla={(actualizar) => {
                if (actualizar) {
                  erecargaComponente((prev) => !prev);
                }
              }}
              mapaEstadosClases={{
                deshabilitado: "CardsCSS-estado-deshabilitado",
                aprobado: "CardsCSS-estado-aprobado",
              }}
              mapaDeComponentes={{
                MPedidoDetalle,
                MPedidoEliminar,
              }}
              reglasDeEstados={[
                {
                  tipo: "deshabilitado",
                  reglas: [
                    {
                      campo: "entregado",
                      criterio: "N",
                      operador: "==",
                      conector: "and",
                    },
                  ],
                },
              ]}
            />
          );
        })}
      </div>
    </div>
  );
}
export default ListarPedidos;
